import { createHOC } from 'vue-hoc';
import omit from 'lodash/omit';
// import isEmpty from 'lodash/isEmpty';

import withUser from './withUser';

export default function withSubscriptionState() {
  return (Component) => {
    const options = {
      name: Component.name + '-with-subscription-state',
    };

    const renderWith = {
      props: {
        subscriptionState() {
          const appMetadata = this.user['https://vrpatients.com/app_metadata'];
          // Disable student purchase:
          // const { subscriptionActive, activeOrg, subscribedOrgs } = appMetadata;
          // const isInSubscribedOrg = !isEmpty(subscribedOrgs) && (!activeOrg || subscribedOrgs[activeOrg])
          return {
            stripeCustomerId: appMetadata.stripeCustomerId,
            // Disable student purchase:
            // active: isInSubscribedOrg
            //     ? !!subscriptionActive
            //     : null,
            // hasPaymentIssue: !!(isInSubscribedOrg && (!appMetadata.stripeCustomerId && !subscriptionActive))
            active: true,
            hasPaymentIssue: false,
          };
        },
      },
    };
    const AugmentedComponent = withUser()(createHOC(Component, options, renderWith));
    AugmentedComponent.props = omit(AugmentedComponent.props, 'subscriptionState');
    return AugmentedComponent;
  };
}
